export default __webpack_public_path__ + "static/media/zagg.4c6d8e57.svg";